const songs = [
    {
      id: 1,
      name: "Song 1",
      author: "Author 1",
    },
    {
      id: 2,
      name: "Song 2",
      author: "Author 2",    
    },
    {
      id: 3,
      name: "Song 3",
      author: "Author 3",
    },
  ];
  

const playlists=[
    {
        id:1,
        name:"Playlist 1",
        user:"user 1",
        image:"https://firebasestorage.googleapis.com/v0/b/vue-imdb-a74a3.appspot.com/o/playlists%2Fplaylist2.jpg?alt=media&token=e23e3ba5-eb63-4a95-8da2-f4f21c5ece16",
        songIds:[1,2]
    },
    {
      id:2,
      name:"Playlist 2",
      user:"user 2",
      image:"https://firebasestorage.googleapis.com/v0/b/vue-imdb-a74a3.appspot.com/o/playlists%2Fmusic.jpg?alt=media&token=90e50ad3-fde2-46b5-8675-4cd0e663189b",
      songIds:[2,3]
  },
  {
    id:3,
    name:"Playlist 3",
    user:"user 3",
    image:"https://firebasestorage.googleapis.com/v0/b/vue-imdb-a74a3.appspot.com/o/playlists%2Fmusic2.jpg?alt=media&token=8f2d584e-8707-459f-808b-4fba768ff13d",
    songIds:[2,3]
},
{
  id:4,
  name:"Playlist 4",
  user:"user 4",
  image:"https://firebasestorage.googleapis.com/v0/b/vue-imdb-a74a3.appspot.com/o/playlists%2Fplaylist1.jpg?alt=media&token=abc274de-9ee6-436e-babd-a97c6aa1ba7b",
  songIds:[2,3]
},
{
  id:5,
  name:"Playlist 5",
  user:"user 5",
  image:"https://firebasestorage.googleapis.com/v0/b/vue-imdb-a74a3.appspot.com/o/playlists%2Fplaylist4.jpg?alt=media&token=2a2f9383-411b-4f8e-aaf7-65a47b8f827d",
  songIds:[2,3]
},
{
  id:6,
  name:"Playlist 6",
  user:"user 6",
  image:"https://firebasestorage.googleapis.com/v0/b/vue-imdb-a74a3.appspot.com/o/playlists%2Fplaylist6.jpg?alt=media&token=6868ac35-2d0f-4578-b920-39d0f44373d6",
  songIds:[2,3]
},
{
  id:7,
  name:"Playlist 7",
  user:"user 7",
  image:"https://firebasestorage.googleapis.com/v0/b/vue-imdb-a74a3.appspot.com/o/playlists%2Fplaylist7.jpg?alt=media&token=2d7b7f33-dfb1-4df1-be95-e47db99d4b3f",
  songIds:[2,3]
},
{
  id:8,
  name:"Playlist 8",
  user:"user 8",
  image:"https://firebasestorage.googleapis.com/v0/b/vue-imdb-a74a3.appspot.com/o/playlists%2Fplaylist8.jpg?alt=media&token=95c388a0-78e7-40ca-88db-b5431d8c937a",
  songIds:[2,3]
}
]
function getSongs() {
    return songs;
  }
  
  function addPlaylist(playlist) {
    playlist.id = playlists.length + 1;
    playlists.push(playlist);
  }
  
  function getPlaylists() {
    return playlists.map(playlist => ({
      id: playlist.id,
      name: playlist.name,
      user:playlist.user,
      image:playlist.image,
      songs: playlist.songIds.map(songId => songs.find(song => song.id === songId)),
    }));
  }
  
 
 export default {
   getSongs,
   addPlaylist,
   getPlaylists
 };